import React from "react";

const AuthoringToolContext = React.createContext();

export default AuthoringToolContext;
